 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, callbacks = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId])
 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				var _m = moreModules[moduleId];

 				// Check if module is deduplicated
 				switch(typeof _m) {
 				case "object":
 					// Module can be created from a template
 					modules[moduleId] = (function(_m) {
 						var args = _m.slice(1), templateId = _m[0];
 						return function (a,b,c) {
 							modules[templateId].apply(this, [a,b,c].concat(args));
 						};
 					}(_m));
 					break;
 				case "function":
 					// Normal module
 					modules[moduleId] = _m;
 					break;
 				default:
 					// Module is a copy of another module
 					modules[moduleId] = modules[_m];
 					break;
 				}
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
 		while(callbacks.length)
 			callbacks.shift().call(null, __webpack_require__);

 	};

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// "0" means "already loaded"
 	// Array means "loading", array contains callbacks
 	var installedChunks = {
 		22:0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.loaded = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
 		// "0" is the signal for "already loaded"
 		if(installedChunks[chunkId] === 0)
 			return callback.call(null, __webpack_require__);

 		// an array means "currently loading".
 		if(installedChunks[chunkId] !== undefined) {
 			installedChunks[chunkId].push(callback);
 		} else {
 			// start chunk loading
 			installedChunks[chunkId] = [callback];
 			var head = document.getElementsByTagName('head')[0];
 			var script = document.createElement('script');
 			script.type = 'text/javascript';
 			script.charset = 'utf-8';
 			script.async = true;

 			script.src = __webpack_require__.p + "" + chunkId + "." + ({}[chunkId]||chunkId) + "-" + {"0":"39abaf23e1eaf6e89013","1":"ad6f11e1a6f839bbea4a","2":"54eb7998c2bf2201cb45","3":"991bfb78285e2cda53dc","4":"32a21f83455fcaf287b2","5":"1af1ce2e1c2cf838898a","6":"b4dff571339120f0ac02","7":"3336c423b52cb299a807","8":"363b7cc4f624ddec1abc","9":"204cd4912903a616ed43","10":"936aa74a46ae61956d17","11":"5eae64b26fcaaf835b59","12":"159e3447e5cc1d02a473","13":"f3516d2ba1eee4bebca6","14":"2628d010c520cad24617","15":"c2c21eeef76805053652","24":"a011acc4537c9b4d8f0b"}[chunkId] + ".js";
 			head.appendChild(script);
 		}
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.99static.com/start/assets/js/";

 	// Load entry module and return exports
 	return __webpack_require__(0);



// WEBPACK FOOTER //
// webpack/bootstrap 1ad168134d4fc40fabba